<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "SC2",
  data() {
    return {};
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import "../../assets/hkapp.css";
</style>